import cx from "classnames";
import React from "react";

import styles from "./PlusProBadge.mscss";

interface OwnProps {
    className?: string;
}

type Props = OwnProps;

export const PlusProBadge: React.FunctionComponent<Props> = ({ className }) => (
    <span className={cx(styles.PlusProBadge, className)}>
        <span className={styles.PlusProBadge__plus}>PLUS</span>
        <span className={styles.PlusProBadge__pro}>PRO</span>
    </span>
);

PlusProBadge.displayName = "PlusProBadge";
